import React from 'react';
import { styled } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const StyledDialog = styled(Dialog)(() => {
  return {
    '.MuiDialog-paperWidthSm': {
      minWidth: '290px',
      margin: 0,
    },
    '.MuiDialogContent-root .MuiBox-root': {
      height: 'auto',
    },
    '.MuiDialog-paper': {
      maxWidth: '90%',
    },
  };
});

const BaseDialog = ({
  children,
  open,
  title,
  cancelText,
  confirmText,
  cancelColor,
  confirmColor,
  onClose,
  onCancel,
  onConfirm,
  isConfirm,
  sx,
  ...properties
}) => {
  return (
    <>
      <StyledDialog
        open={open}
        onClose={onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        sx={Object.assign(sx, {
          minWidth: '290px',
          margin: '0',
        })}
        {...properties}
      >
        <DialogTitle id="dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions sx={{ padding: '20px' }}>
          {isConfirm ? (
            <Button
              onClick={onCancel || onClose}
              variant="contained"
              color={cancelColor}
              sx={{
                paddingLeft: '20px',
                paddingRight: '20px',
                minWidth: '5rem',
              }}
            >
              {cancelText}
            </Button>
          ) : undefined}

          <Button
            onClick={onConfirm}
            variant="contained"
            color={confirmColor}
            sx={{ paddingLeft: '20px', paddingRight: '20px', minWidth: '5rem' }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
};

BaseDialog.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelColor: PropTypes.string,
  confirmColor: PropTypes.string,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  isConfirm: PropTypes.bool,
  sx: PropTypes.object,
};

BaseDialog.defaultProps = {
  title: '系統訊息',
  cancelText: '取消',
  confirmText: '確定',
  cancelColor: 'error',
  confirmColor: 'primary',
  onClose: () => {},
  onCancel: () => {},
  onConfirm: () => {},
  isConfirm: false,
  sx: {},
};

export default BaseDialog;
